import { logs } from "./data";

const ChangeLogs = () => {
  return (
    <main className="min-h-screen bg-slate-100 px-4 py-6 sm:px-6 lg:px-8 overflow-y-auto" dir="rtl">
      <div className="mx-auto max-w-4xl h-full overflow-y-auto max-h-screen pb-8">
        <header className="mb-8 rounded-3xl bg-gradient-to-l from-slate-900 to-slate-700 px-6 py-7 text-white shadow-lg sm:px-8">
          <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="mb-2 text-sm font-medium text-slate-300">{logs[0]?.title}</p>
              <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">تاریخچه تغییرات پروژه</h1>
              <p className="mt-3 max-w-2xl text-sm leading-7 text-slate-300">
                آخرین تغییرات و بهبودهای انجام‌شده در پنل کاربری
              </p>
            </div>
            <div className="w-fit rounded-2xl border border-white/15 bg-white/10 px-4 py-3 text-center backdrop-blur-sm">
              <span className="block text-2xl font-bold">{logs.length}</span>
              <span className="text-xs text-slate-300">نسخه ثبت‌شده</span>
            </div>
          </div>
        </header>

        <section className="relative space-y-4 " aria-label="فهرست تغییرات">
          {logs.map((log) => (
            <article
              key={`${log.version}-${log.date}`}
              className="relative rounded-2xl border border-slate-200 bg-white p-2"
            >
              <div className="mb-5 flex flex-col gap-3 border-b border-slate-100 pb-4 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex items-center gap-3">
                  <span
                    className="rounded-xl bg-primary-50 px-3 py-1.5 text-sm font-bold text-primary-700"
                    dir="ltr"
                  >
                    نسخه {log.version}
                  </span>
                  <span className="h-1.5 w-1.5 rounded-full bg-slate-300" />
                  <time className="text-sm text-slate-500" dateTime={log.date} dir="ltr">
                    {log.date}
                  </time>
                </div>
                <span className="text-xs font-medium text-slate-400">{log.title}</span>
              </div>

              <ul className="space-y-3 text-sm leading-7 text-slate-700">
                {log.changes.map((change, index) => (
                  <li key={`${log.version}-${index}`} className="flex items-start gap-3">
                    <span
                      className="mt-2.5 h-2 w-2 shrink-0 rounded-full bg-primary-400"
                      aria-hidden="true"
                    />
                    - <span>{change}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </section>
      </div>
    </main>
  );
};

export default ChangeLogs;
